interface GetAlgoliaHitUrlProps {
  countryId?: string
  queryId?: string
  url: string
}

export const getAlgoliaHitUrl = ({ countryId, queryId, url }: GetAlgoliaHitUrlProps): string => {
  if (countryId === 'DE' || countryId === 'NL') {
    return url
  }

  let finalUrl = 'https://www.billy.dk' + url

  if (queryId) {
    finalUrl += `&queryID=${queryId}`
  }

  return finalUrl
}
